import Login from './views/Login.vue'
import NotFound from './views/404.vue'
import Home from './views/Home.vue'

let routes = [{
        path: '/login',
        component: Login,
        name: '',
        hidden: true,
        meta: {
            permission: [1, 2, 3]
        }
    },
    {
        path: '/404',
        component: NotFound,
        name: '',
        hidden: true,
        meta: {
            permission: [1, 2, 3]
        }
    },
    {
        path: '/',
        component: Home,
        name: '',
        iconCls: '',
        leaf: true, //只有一个节点
        meta: {
            permission: [2, 3]
        },
        children: [{
            path: '/merchant',
            component: () => import('@/views/merchant'),
            name: '商家管理',
            meta: {
                permission: [2, 3]
            }
        }]
    },
    {
        path: '/',
        component: Home,
        name: '',
        iconCls: '',
        leaf: true, //只有一个节点
        meta: {
            permission: [1, 2, 3]
        },
        children: [{
            path: '/product',
            component: () => import('@/views/product'),
            name: '商品管理',
            meta: {
                permission: [1, 2, 3]
            }
        }]
    },
    {
        path: '/',
        component: Home,
        name: '',
        iconCls: '',
        leaf: true, //只有一个节点
        meta: {
            permission: [1, 2, 3]
        },
        children: [{
            path: '/order',
            component: () => import('@/views/order'),
            name: '订单管理',
            meta: {
                permission: [1, 2, 3]
            }
        }]
    },
    {
        path: '/',
        component: Home,
        name: '',
        iconCls: '',
        leaf: true, //只有一个节点
        meta: {
            permission: [1, 2, 3]
        },
        children: [{
            path: '/contract',
            component: () => import('@/views/contract'),
            name: '合同管理',
            meta: {
                permission: [1, 2, 3]
            }
        }]
    },
    {
        path: '*',
        hidden: true,
        redirect: {
            path: '/404'
        },
        meta: {
            permission: [1, 2, 3]
        }
    }
];

export default routes;


// WEBPACK FOOTER //
// ./src/routes.js